export enum EstiloFormularioEnum
{
    Inclusao = 1,
	Alteracao = 2,
	Visualicacao = 3
}